var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocationPinDrop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 48,
    viewBox: "0 0 32 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8779_161620)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.0112 13.3719C29.1869 6.32423 23.1133 0.937992 15.9863 0.963592C13.1984 0.973832 10.5719 1.68807 8.26916 3.29319C3.41796 6.67495 1.30212 11.3342 2.09828 17.2234C2.47332 19.9972 3.51652 22.579 4.67236 25.1082C7.5498 31.402 11.2567 37.2042 15.2541 42.8311C15.8007 43.6004 16.186 43.5978 16.7658 42.8349C19.432 39.3226 21.8896 35.6708 24.0951 31.8513C26.0432 28.4759 27.7943 25.0058 28.9898 21.281C29.8154 18.7108 30.33 16.0996 30.0112 13.3719V13.3719Z",
    stroke: "#282929",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5163 39C24.9768 39.3062 27.436 39.6574 29.6379 40.9223C31.4551 41.9659 31.4489 43.5669 29.6502 44.6631C28.2374 45.523 26.6555 45.8967 25.0638 46.2041C21.8694 46.8203 18.6407 47.024 15.1203 46.9978C11.8891 46.9303 8.40065 46.6816 5.00529 45.7304C4.07282 45.4692 3.18814 45.0205 2.29978 44.6143C2.01673 44.4856 1.76799 44.2456 1.54866 44.0119C0.834299 43.2545 0.792639 42.2571 1.57072 41.5722C2.15887 41.056 2.87078 40.6448 3.58882 40.3311C5.14253 39.6524 6.80896 39.3812 8.46927 39.1187",
    stroke: "#282929",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9644 21.8387C12.1807 21.7798 9.17146 18.7219 9.23034 14.9958C9.2905 11.239 12.3689 8.24507 16.1193 8.29755C19.8223 8.35003 22.8508 11.4745 22.783 15.1724C22.7139 18.8883 19.6367 21.8963 15.9644 21.8387Z",
    stroke: "#282929",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8779_161620"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 48,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPinDrop);
export default __webpack_public_path__ + "static/media/location-pin-drop.83bf81ca.svg";
export { ForwardRef as ReactComponent };